export { Ng2TelInputModule } from './src/ng2-tel-input.module';
export { Ng2TelInput } from './src/ng2-tel-input';
//# sourceMappingURL=ng2-tel-input.js.map